/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Submit_UpdateInputs */

const he_notifications_submit_update = /** @type {(inputs: Notifications_Submit_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`עדכון התראה`)
};

const en_notifications_submit_update = /** @type {(inputs: Notifications_Submit_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Notification`)
};

/**
* | output |
* | --- |
* | "Update Notification" |
*
* @param {Notifications_Submit_UpdateInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_submit_update = /** @type {((inputs?: Notifications_Submit_UpdateInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Submit_UpdateInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_submit_update(inputs)
	return en_notifications_submit_update(inputs)
});